import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type EditReservationDTO = {
    status:string
};

type ReservationResponse  = object & ApiError;

export const EditReservation = (data: EditReservationDTO , id:string): Promise<ReservationResponse> => {
    return axios.patch(`/consultant-booking/${id}`, data)
        .then(response => response.data as ReservationResponse);
};